
import React, { Component } from 'react';
import { Grid, Header } from "semantic-ui-react";
import collections from '../../api/collections';
import OptionsModal from '../modals/OptionsModal';
import DataGrid from '../shared/DataGrid';

class BaseBreakdownTab extends Component {

  meterGridKey = "meterGrid";
  detailGridKey = "detailGrid";

  state = {
    modalOpen: false,
    loading: false,
    modalOptions: [],
    activeRow: null,
    modalTitle: "",
    meterRef: null
  }

  onRowClick = (activeRow) => { 
    if (activeRow.optionAllowEdit) {
      this.setState({ loading: true }, () => {
        collections.editMeter(activeRow.meterRef).then(
          result => {
            this.setState({ modalTitle: activeRow.name, loading: false, ...result, modalOpen: true })
          }
        );
      })
    }
  }
  
  closeModal = () => {
    this.setState({ modalOpen: false }, () => this.props.modal.onRefresh())
  }

  handleSave = async (changed) => {
    const { meterRef } = this.state;
    collections.updateMeter(meterRef, changed).then(response => {
      this.props.showSuccessAlert(response, "Success", async () => {
        this.setState({ modalOpen: false }, () => {
          console.log(this.props.modal);
          this.props.modal.onRefresh()
        })
      })
    });
  }

  render() {
    const { varianceHistory, optionShowVariance, showMetersGrid } = this.props.modal
    const { controls, modalOpen, loading } = this.state;
    const { allowShowMeters } = this.props;

    const meterGrid = this.props.modal[this.meterGridKey];
    const detailGrid = this.props.modal[this.detailGridKey];

    const showSecondGrid = showMetersGrid && allowShowMeters;

    return (
      <Grid columns={showSecondGrid ? "2" : "1"} className="height-100 flex-container" padded="vertically">
        <Grid.Row className="flex-stretch">
          <Grid.Column className="gs-flex-container-vertical">
            <DataGrid
              headings={detailGrid.headerDef}
              data={detailGrid.data}
              rowDef={detailGrid.rowDef}
              hideOverflow
              onRowClick={this.props.onDetailsRowClick}
              fullHeight
            />
          </Grid.Column>
          { showSecondGrid &&
            <Grid.Column className="gs-flex-container-vertical">
              <OptionsModal open={modalOpen} options={controls} title={`Edit Meter - ${this.state.modalTitle}`} onClose={this.closeModal} onSave={this.handleSave} />
              <DataGrid
                headings={meterGrid.headerDef}
                data={meterGrid.data}
                rowDef={meterGrid.rowDef}
                onRowClick={this.onRowClick}
                loading={loading}
                hideOverflow
                disableSort
                fullHeight
              />
            </Grid.Column>
          }
        </Grid.Row>
        {optionShowVariance &&
          <Grid.Row style={{ paddingBottom: "0" }}>
            <Grid.Column width="16" classname="gs-flex-container-vertical">
              <Header size="tiny">Variance History</Header>
              <DataGrid
                headings={varianceHistory.headerDef}
                data={varianceHistory.data}
                rowDef={varianceHistory.rowDef}
                onRowClick={() => { }}
                hideOverflow
              />
            </Grid.Column>
          </Grid.Row>
        }
      </Grid>
    )
  }
}

export default BaseBreakdownTab;